import { Component, OnInit } from '@angular/core';
import { VisitService } from '../../service/table/visit.service';
import { TableComponent } from '../../components/table/table.component';

@Component({
  selector: 'app-visit',
  templateUrl: './visit.component.html',
  standalone: true,
  imports: [TableComponent],
  styleUrls: ['./visit.component.scss']
})
export class VisitComponent implements OnInit {

  visitService: VisitService;

  constructor(private service: VisitService) {
    this.visitService = service;
  }

  ngOnInit() {
  }
}
